import React from "react";

const Flare = () => {
  return <div>Flare Page</div>;
};

export default Flare;
